@if (!callTime) {
  <div class="availability">
    <span class="availability-label">Availabilities</span>
    @if (timezoneName) {
      <ul class="availability-list">
        @if (requestedAnotherTime) {
          <li class="new-requested-pill availability-pill">
            <span class="material-icons-outlined">warning</span>
            <span class="availability-pill-text">New date requested</span>
          </li>
        }
        @for (availability of slots.slice(0, requestedAnotherTime ? 1 : 2); track availability) {
          <li class="availability-pill">
            <span
              class="availability-pill-text"
              [title]="moment(availability.start).tz(timezoneName).format('ddd Do MMM LT (z)')"
            >
              {{ moment(availability.start).tz(timezoneName).format('ddd Do MMM LT (z)') }}
            </span>
          </li>
        }
        @if (slots.length > (requestedAnotherTime ? 1 : 2)) {
          <li class="ellipse-box">
            <span>...</span>
            <div class="drop-down">
              @for (availability of slots.slice(2); track availability) {
                <div class="drop-down-item flex availability-pill">
                  <span class="availability-pill-text">
                    {{ moment(availability.start).tz(timezoneName).format('ddd Do MMM LT (z)') }}
                  </span>
                </div>
              }
            </div>
          </li>
        }
      </ul>
    }
    @if (!timezoneName) {
      <p>Please assign a country and a timezone to this expert</p>
    }
  </div>
} @else {
  <div class="availability">
    <span class="availability-label">Requested Call Time</span>
    <div class="availability-pill requested-call-time">
      @if (timezoneName) {
        <span class="availability-pill-text" [title]="moment(callTime).tz(timezoneName).format('ddd Do MMM LT (z)')">
          {{ moment(callTime).tz(timezoneName).format('ddd Do MMM LT (z)') }}
        </span>
      }
      @if (!timezoneName) {
        <span class="availability-pill-text" [title]="moment(callTime).tz('UTC').format('ddd Do MMM LT (z)')">
          {{ moment(callTime).tz('UTC').format('ddd Do MMM LT (z)') }}
        </span>
      }
    </div>
  </div>
}
